<template>
  <div class="sign_container">
    <Tabbar v-show="submitShow" data-html2canvas-ignore title="Online Signing" background="#378e5b"></Tabbar>
    <div class="flex jc-sb head_box">
      <img class="logo" src="../assets/chamet_logo.png" alt="" />
      <div>
        <div>Mobile: +85266812971</div>
        <div>Email: bd@hkfuliao.com</div>
      </div>
    </div>
    <div class="title bold">FULIAO HONG KONG LIMITED</div>
    <div>
      <span class="bold">{{ $t('signing.employeeName') }}: </span>{{ wagesDetail.employeeName }}
    </div>
    <div>
      <span class="bold">{{ $t('signing.designation') }}: </span>{{ wagesDetail.designation }}
    </div>
    <div>
      <span class="bold">{{ $t('signing.month') }}: </span>{{ wagesDetail.month }}
    </div>
    <div>
      <span class="bold">{{ $t('signing.year') }}: </span>{{ wagesDetail.year }}
    </div>
    <table :border="1">
      <tr>
        <th colspan="2" class="bold">{{ $t('signing.earnings') }}</th>
        <th colspan="2" class="bold">{{ $t('signing.deductions') }}</th>
      </tr>
      <tr>
        <td>{{ $t('signing.basic') }}</td>
        <td>{{ wagesDetail.basicUsd }}</td>
        <td></td>
        <td>-</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td>-</td>
      </tr>
      <tr>
        <td>{{ $t('signing.totalAddition') }}</td>
        <td>{{ wagesDetail.totalAddition }}</td>
        <td>{{ $t('signing.totalDeduction') }}</td>
        <td>{{ wagesDetail.totalDeduction }}</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td class="bold">{{ $t('signing.salary') }}</td>
        <td class="bold">{{ wagesDetail.netSalary }}</td>
      </tr>
    </table>

    <div class="flex text_left bottom">
      <div>
        <div>
          <span class="bold">{{ $t('signing.refNo') }}: </span>{{ wagesDetail.refNo }}
        </div>
        <div class="bold">{{ $t('signing.paymentTransferDate') }}:</div>
        <div>{{ wagesDetail.paymentTransferDate }}</div>
      </div>
      <div class="bank_name">
        <div class="bold">{{ $t('signing.nameOfBank') }}:</div>
        <div>{{ wagesDetail.nameOfBank }}</div>
      </div>
    </div>
    <div class="flex sign_area">
      <div class="bold">
        {{ $t('signing.signatureOfEmployee') }}:
        <div data-html2canvas-ignore @click="signNow" class="sign_btn">
          {{ signBtn }}
        </div>
      </div>
      <div class="bold right_sign">{{ $t('signing.director') }}:</div>
    </div>
    <div class="sign_show_area flex">
      <img class="sign_img sign_imgA" v-show="signImgShow" :src="signImgSrc" alt="" />
      <img class="sign_img sign_imgB" src="../assets/signA.png" alt="" />
    </div>
    <div class="footer">SUITE 603 6/F LAWS COMM PLAZA 788 CHEUNG SHA WAN RD KL</div>
    <ESignature page="payrollImg" @cancel="cancel" v-show="signShow"></ESignature>
    <ScreenAndSubmit
      data-html2canvas-ignore
      v-show="submitShow"
      :signImgSrc="signImgSrc"
      page="wagesImg"
    ></ScreenAndSubmit>
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar.vue'
import ESignature from '@/components/ESignature.vue'
import ScreenAndSubmit from '@/components/ScreenAndSubmit.vue'

export default {
  name: 'SigningPayroll',
  components: { ESignature, Tabbar, ScreenAndSubmit },
  data() {
    return {
      signShow: false,
      submitShow: true,
      signImgShow: false,
      signImgSrc: '',
      signBtn: 'Sign Now',
      wagesDetail: ''
    }
  },
  mounted() {
    if (sessionStorage.getItem('wagesDetail')) {
      this.wagesDetail = JSON.parse(sessionStorage.getItem('wagesDetail'))
    }
    if (sessionStorage.getItem('payrollImg')) {
      this.signImgShow = true
      this.signImgSrc = sessionStorage.getItem('payrollImg')
      this.signBtn = 'Resign'
    }
  },
  methods: {
    signNow() {
      this.signShow = true
      this.submitShow = false
      console.log(this.signShow)
    },
    cancel() {
      this.signShow = false
      this.submitShow = true
    }
  }
}
</script>

<style scoped>
.sign_container {
  width: 100vw;
  min-height: 100vh;
  font-size: 0.14rem;
  padding: 0.18rem 0.18rem 0.8rem;
  box-sizing: border-box;
  overflow-x: hidden;
  background: url(../assets/chamet_logo_bg.png) repeat;
  text-align: center;
  line-height: 0.2rem;
  position: relative;
}

.logo {
  width: 0.7rem;
  height: 0.7rem;
}

.title {
  font-size: 0.16rem;
  margin: 0.1rem 0;
  padding: 0;
}

.flex {
  display: flex;
  align-items: center;
}

.jc-sb {
  justify-content: space-between;
}

table {
  width: 100%;
  margin: 0.1rem 0;
}

table,
td,
th {
  border-collapse: collapse;
  border: 1px solid #999;
}

.bold {
  font-weight: bold;
}

.text_left {
  text-align: left;
}

.bottom {
  align-items: start;
  margin-bottom: 0.1rem;
  justify-content: space-between;
}

.bank_name {
  max-width: 1.3rem;
  word-wrap: break-word;
}

.inwords {
  margin: 0.1rem 0;
}

.footer {
  width: 100%;
  font-size: 0.09rem;
  text-align: center;
  margin-top: 0.3rem;
}

.right_sign {
  margin-inline-start: 0.6rem;
}

.sign_img {
  width: 1rem;
  height: 0.6rem;
  object-fit: contain;
  margin-inline-start: 0.2rem;
}

.sign_imgB {
  margin-inline-start: 1rem;
}

.sign_btn {
  width: max-content;
  background: #378e5b;
  color: #fff;
  padding: 0.03rem 0.1rem;
  box-sizing: border-box;
  text-align: center;
  border-radius: 0.2rem;
}

.sign_show_area {
  width: 100%;
  justify-content: flex-end;
  margin-top: 0.1rem;
}

.sign_area {
  text-align: left;
  align-items: start;
}
</style>



// WEBPACK FOOTER //
// src/views/SigningPayroll.vue